import { render } from "./FormTrainingHeadFields.vue?vue&type=template&id=6a33413c&scoped=true&ts=true"
import script from "./FormTrainingHeadFields.vue?vue&type=script&lang=ts"
export * from "./FormTrainingHeadFields.vue?vue&type=script&lang=ts"

import "./FormTrainingHeadFields.vue?vue&type=style&index=0&id=6a33413c&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a33413c"]])

export default __exports__